import React from 'react';
import { useSelector } from 'react-redux';

import FormChangesBlade from './FormChangesBlade';
import SelectedSubGrids from './SelectedSubGrids';
import CustomLoader from '../../components/CustomLoader';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt';
import { FORM_KEYS } from '../constants/form-manager.constants';
import { FormContext } from '../context';
import FormRulesController from '../controllers/FormRulesController';
import ValueOverrideController from '../controllers/ValueOverrideController';
import FormManager from '../FormManager';
import { formHasUnsavedChanges } from '../selectors/runtime.selectors';
import VirtualFormManager from '../virtual-layout/VirtualFormManager';

const StepForm = ({ isLoading, isViewOnly = false }) => {
  const hasUnsavedChanges = useSelector((state) =>
    formHasUnsavedChanges(state, { formKey: FORM_KEYS.STEP })
  );

  return isLoading ? (
    <CustomLoader />
  ) : (
    <FormContext.Provider value={FORM_KEYS.STEP}>
      <FormManager isDetail={isViewOnly} />
      <VirtualFormManager />
      <ValueOverrideController />
      <FormRulesController />
      <UnsavedChangesPrompt hasUnsavedChanges={hasUnsavedChanges} />
      <SelectedSubGrids />
      <FormChangesBlade />
    </FormContext.Provider>
  );
};

export default StepForm;
